import _vsop87Bearth from 'astronomia/data/vsop87Bearth'
export const vsop87Bearth = _vsop87Bearth
